import React from 'react';
import { Link } from 'react-router-dom';
import { LeaderboardAd, InArticleAd, FooterAd, MultiplexAd, SidebarAd } from './AdSense';
import { useSEO } from '../context/SEOContext';
import SEOMeta from './SEOMeta';
import Footer from './Footer';
// import { CALC_ROUTES } from '../App';
import { CALC_ROUTES } from '../config/Calc_Routes';

const CAT_COLORS = { Loan: 'var(--blue)', Investment: 'var(--green)', Tax: 'var(--orange)', Business: 'var(--purple)' };
const CAT_ICONS = { Loan: '🏦', Investment: '📈', Tax: '📋', Business: '🏢' };

export default function Home() {
  const { getSEO } = useSEO();
  const seo = getSEO('/');

  return (
    <>
      <SEOMeta path="/" />
      <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '0 16px' }}>
        {/* Top Ad */}
        <div style={{ padding: '14px 0 4px' }}><LeaderboardAd /></div>

        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(135deg, rgba(255,107,44,0.08) 0%, transparent 60%)',
          border: '1px solid rgba(255,107,44,0.18)',
          borderRadius: '20px', padding: 'clamp(20px,4vw,40px)',
          margin: '14px 0 28px',
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '28px', alignItems: 'center' }}>
            <div>
              <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', background: 'rgba(255,107,44,0.12)', border: '1px solid rgba(255,107,44,0.25)', borderRadius: '100px', padding: '5px 14px', marginBottom: '16px', fontSize: '12px', color: 'var(--orange)', fontWeight: 700 }}>
                🇮🇳 Made for India
              </div>
              <h1 style={{ fontSize: 'clamp(26px,5vw,50px)', fontWeight: 900, lineHeight: 1.1, letterSpacing: '-0.8px', marginBottom: '14px' }}>
                {seo.h1}
              </h1>
              <p style={{ fontSize: 'clamp(14px,2vw,16px)', color: 'var(--t2)', lineHeight: 1.7, marginBottom: '22px', maxWidth: '520px' }}>
                {seo.intro}
              </p>
              <div style={{ display: 'flex', gap: '9px', flexWrap: 'wrap' }}>
                {[['🏦 EMI', '/emi'], ['📈 SIP', '/sip'], ['📋 Tax', '/income-tax'], ['📊 GST', '/gst']].map(([n, p]) => (
                  <Link key={p} to={p} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '100px', padding: '8px 16px', color: 'var(--t2)', textDecoration: 'none', fontSize: '13px', fontWeight: 600, transition: 'all 0.2s', whiteSpace: 'nowrap' }}
                    onMouseEnter={e => { e.currentTarget.style.borderColor = 'var(--orange)'; e.currentTarget.style.color = 'var(--orange)'; }}
                    onMouseLeave={e => { e.currentTarget.style.borderColor = 'var(--border)'; e.currentTarget.style.color = 'var(--t2)'; }}>
                    {n}
                  </Link>
                ))}
              </div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
              {[['30+', 'Calculators'], ['100%', 'Free'], ['🇮🇳', 'Indian Finance'], ['Fast', '& Accurate']].map(([v, l]) => (
                <div key={l} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '12px', padding: '14px 16px', textAlign: 'center', transition: 'background 0.3s' }}>
                  <div style={{ fontSize: '20px', fontWeight: 800, color: 'var(--orange)', marginBottom: '2px' }}>{v}</div>
                  <div style={{ fontSize: '11px', color: 'var(--t3)' }}>{l}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Content + Sidebar */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '24px' }}>
          <div className="home-layout">
            <main>
              {Object.entries(CALC_ROUTES).map(([cat, items], ci) => (
                <section key={cat} style={{ marginBottom: '36px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
                    <div style={{ width: '40px', height: '40px', background: `${CAT_COLORS[cat]}18`, border: `1px solid ${CAT_COLORS[cat]}35`, borderRadius: '11px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px' }}>{CAT_ICONS[cat]}</div>
                    <div>
                      <h2 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--t1)', marginBottom: '2px' }}>{cat} Calculators</h2>
                      <p style={{ fontSize: '12px', color: 'var(--t2)' }}>{items.length} free calculators</p>
                    </div>
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '11px' }}>
                    {items.map(item => (
                      <Link key={item.path} to={item.path} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '14px', padding: '15px', textDecoration: 'none', transition: 'all 0.2s', display: 'block' }}
                        onMouseEnter={e => { e.currentTarget.style.borderColor=`${CAT_COLORS[cat]}`; e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow=`0 8px 24px ${CAT_COLORS[cat]}15`; }}
                        onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border)'; e.currentTarget.style.transform='none'; e.currentTarget.style.boxShadow='none'; }}>
                        <div style={{ width: '36px', height: '36px', background: `${CAT_COLORS[cat]}14`, borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '19px', marginBottom: '10px' }}>{item.icon}</div>
                        <div style={{ fontSize: '13.5px', fontWeight: 700, color: 'var(--t1)', marginBottom: '4px', lineHeight: 1.3 }}>{item.name}</div>
                        <div style={{ fontSize: '11.5px', color: 'var(--t2)', marginBottom: '10px' }}>{item.desc}</div>
                        <div style={{ fontSize: '11px', color: CAT_COLORS[cat], fontWeight: 700 }}>Calculate →</div>
                      </Link>
                    ))}
                  </div>
                  {ci === 1 && <div style={{ margin: '20px 0' }}><InArticleAd /></div>}
                </section>
              ))}

              {/* SEO content block */}
              <section style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '16px', padding: '24px', marginBottom: '28px' }}>
                <h2 style={{ fontSize: '18px', fontWeight: 800, color: 'var(--t1)', marginBottom: '12px' }}>About Apnaa Calculator</h2>
                <p style={{ fontSize: '14px', color: 'var(--t2)', lineHeight: 1.8, marginBottom: '12px' }}>
                  Apnaa Calculator is India's most comprehensive free financial calculator platform. Whether you need to calculate your home loan EMI, plan your SIP investments, understand your income tax liability, or compute GST on a transaction — we have a calculator for everything.
                </p>
                <p style={{ fontSize: '14px', color: 'var(--t2)', lineHeight: 1.8 }}>
                  All our calculators are based on the latest Indian tax laws and financial regulations for FY 2024-25. They are completely free, require no login, and work instantly on all devices.
                </p>
              </section>
              <MultiplexAd />
            </main>

            {/* Sidebar */}
            <aside style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
              <SidebarAd slot="3333333333" />
              <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: '14px', padding: '16px' }}>
                <div style={{ fontSize: '11px', fontWeight: 700, color: 'var(--t3)', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '12px' }}>Why Apnaa Calculator?</div>
                {['✅ 100% Free — Always', '✅ Latest Indian Tax Slabs', '✅ No Login Required', '✅ Mobile Friendly', '✅ Fast & Accurate', '✅ 30+ Calculators'].map(f => (
                  <div key={f} style={{ fontSize: '13px', color: 'var(--t2)', marginBottom: '7px' }}>{f}</div>
                ))}
              </div>
              <SidebarAd slot="4444444444" />
            </aside>
          </div>
        </div>
        <FooterAd />
        <div style={{ height: '16px' }} />
      </div>
      <Footer />
    </>
  );
}
